import axios from "axios";
import HandleLogout from "../hooks/handleLogout";

const handleAxiosResponse = (response) => {
  if (response?.status === 401) {
    HandleLogout();
  }

  return response;
};

const normalizeAxiosError = (err) => {
  if (err?.response) {
    return handleAxiosResponse(err.response);
  }

  return {
    status: 0,
    data: {
      message: err?.message || "Network error. Please try again.",
    },
  };
};

const getApiUrl = (endpoint) => {
  const baseUrl = (process.env.REACT_APP_API_URL || "").trim().replace(/\/+$/, "");
  const cleanEndpoint = String(endpoint || "").replace(/^\/+/, "");
  return `${baseUrl}/${cleanEndpoint}`;
};

export const AxiosGetMethod = async (endpoint, unauthorised, customHeader) => {
  let headers = {};
  if (!unauthorised) {
    const token = localStorage.getItem("dwt-tok");
    headers = {
      ...headers,
      ...{ Authorization: `Bearer ${token}` },
    };
  }
  if (customHeader) {
    headers = {
      ...headers,
      ...customHeader,
    };
  }
  return await axios
    .get(getApiUrl(endpoint), {
      headers,
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return normalizeAxiosError(err);
    });
};

export const AxiosPostMethod = async (
  endpoint,
  body,
  unauthorised,
  formData
) => {
  // body = await geturlsearchbody(body);
  let headers = {};
  if (!unauthorised) {
    const token = localStorage.getItem("dwt-tok") || localStorage.getItem("dwt-tok-otp");
    headers = {
      ...headers,
      ...{ Authorization: `Bearer ${token}` },
    };
  }
  if (formData) {
    // Let Axios set the multipart/form-data boundary automatically.
    headers = {
      ...headers,
      ...{
        Accept: "application/json",
      },
    };
  }
  return await axios
    .post(getApiUrl(endpoint), body, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return normalizeAxiosError(err);
    });
};

export const AxiosPutMethod = async (
  endpoint,
  body,
  unauthorised,
  formData
) => {
  // body = await geturlsearchbody(body);
  let headers = {};
  if (!unauthorised) {
    const token = localStorage.getItem("dwt-tok");
    headers = {
      ...headers,
      ...{ Authorization: `Bearer ${token}` },
    };
  }
  if (formData) {
    headers = {
      ...headers,
      ...{
        "Content-Type": "multipart/form-data",
      },
    };
  }
  return await axios
    .put(getApiUrl(endpoint), body, { headers })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return normalizeAxiosError(err);
    });
};
